import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddc4a7de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner flex flex-col" }
const _hoisted_2 = {
  class: "flex flex-row flex-1 text-black",
  style: {"height":"0"}
}
const _hoisted_3 = { class: "left-scorll flex-1 px-8" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "banner-content" }
const _hoisted_6 = {
  key: 0,
  class: "inputFram text-black"
}
const _hoisted_7 = { class: "flex-1 mb-0" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  style: {"color":"#13C2C2"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"1px","height":"100%","background":"#DCDCDC"} }, null, -1))
const _hoisted_11 = { class: "flex flex-col mx-8 keyBoradContent" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-3xl" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-3xl" }, "材废填写", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "subButton flex flex-row items-center justify-between" }
const _hoisted_19 = { class: "text-black flex-1 overflow-hidden" }
const _hoisted_20 = {
  key: 0,
  class: "w-full px-8"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_tips" }, "选中工序将同时完工", -1))
const _hoisted_22 = { class: "flex items-center process_over" }
const _hoisted_23 = { class: "flex items-center justify-end" }
const _hoisted_24 = {
  class: "flex text-xl",
  style: {"color":"#5E5E5E"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "计划数", -1))
const _hoisted_26 = { class: "flex-1 text-right" }
const _hoisted_27 = {
  class: "flex text-xl",
  style: {"color":"#5E5E5E"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前正品数", -1))
const _hoisted_29 = { class: "flex-1 text-right" }

import { IPostMachineProductionCountReportMaterialBadDetailList, IPostMachineProductionMachineOperationCountReportInVo } from "@/api/machine/index.type.public";
import { message, SelectProps } from "ant-design-vue";
import { PropType, ref, watch, onMounted, computed } from "vue";
import { EllipsisOutlined } from '@ant-design/icons-vue';
import keyBorad from './keyBorad.vue';
import MessageShow from './MessageShow.vue';
import jtabBar from "@/components/jtabs-2/index.vue";
import titleButton from "./title-button.vue"
import JablilBtn from "./ablilit-btn.vue"
import reportTitle from "./reportTitle.vue"
import { useStore } from "vuex";
import { IPostMachineProductionGetCurProductionWorkOrderListVo } from "@/api/machine";
export interface IItemData {
    /**
     * 对照字段id
     */
    filed: string;

    /**
     * 支持的类型
     */
    filedType: string | 'select' | 'input';

    /**
     * 标题内容
     */
    title: string;
    /**
     * 存储具体值
     */
    value: string;
    /**
     * 按钮是否禁用
     */
    disabled: boolean;

    /**
     * 是否允许键盘编辑
     */
    isEdit: boolean;


    /**
     * 触发对象
     */
    vaild?: number;


    /**
     * 默认是展示还是隐藏
     */
    hide: boolean;
    icon: boolean;
}

//---------------------传入参数、回调、监听定义---------------------
//定义传入变量

export default /*#__PURE__*/_defineComponent({
  __name: 'CompletionReport-2',
  props: {
    /**
     * 默认值赋予
     */
    data: {
        required: false,
        type: Object as PropType<IPostMachineProductionMachineOperationCountReportInVo>,
    },
    /**
   * 记录上报时候的正品数
   */
    recordGoodNum: {
        required: false,
        type: Number || String,
    },
    /**
     * 计划生产数
     */
    planOutput: {
        required: true,
        type: Number,
    },
    //移除mark点击操作
    maskClosable: {
        required: false,
        type: Boolean,
        default: true
    },
    productionData: {
        required: false,
        type: Object as PropType<IPostMachineProductionGetCurProductionWorkOrderListVo>,
    },
    //正品数
    goodOutput: {
        required: false,
        type: Number,
    }
},
  emits: ["onResultOperate"],
  setup(__props, { emit }: { emit: ({
    //返回操作
    (e: "onResultOperate", status: 'cance' | 'complete', data: IItemData[], wastList, type: string, num: number | string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;



// //定义监听事件
watch(
    () => props.data,
    (newVal: any) => {
        bableFun(newVal)
    }
);
watch(() => props.goodOutput, val => {
    console.log(val,'val');
    if (val) {
        message.destroy()
        message.warning('当前设备仍在运行中，有正品数增加。');
    }
})
const bableFun = (newVal: any) => {
    let list = newVal
    //变更执行事件
    goodOutputOldValue.value = list.goodOutput + '';
    //组装动态列表
    let filedFileds = ['goodOutput', 'adjustmentReason', 'workBadOutput', 'materialBadOutput', 'customOutput',]
    let filedTitle = ['正品数', '修改原因', '工废', '材废', '自定义']
    let filedDisabled = [false, props.data.goodOutputAdjustment == 0 ? true : false, false, false, false]
    let filedEditd = [true, false, true, true, true]
    let filedsType = ['input', 'select', 'input', 'input', 'input']
    let filedsVaild = [1, -1, -1, -1, -1]
    let filedsHide = [false, false, false, false, true]
    let filedIconShow = [false, false, false, true, false]
    let itemDataList: IItemData[] = [];
    for (let index = 0; index < filedFileds.length; index++) {
        const element = filedFileds[index];
        itemDataList.push({
            filed: element,
            title: filedTitle[index],
            filedType: filedsType[index],
            value: filedsType[index] == 'select' ? (list[element] ? list[element] : undefined) : list[element],
            isEdit: filedEditd[index],
            disabled: filedDisabled[index],
            vaild: filedsVaild[index],
            hide: filedsHide[index],
            icon: filedIconShow[index],
        })
    }
    materialBadDetailList.value = store.state.inforReport.statue ? store.state.inforReport.wastList : list.materialBadDetailList
    dataInfo.value = store.state.inforReport.statue ? store.state.inforReport.inforList : itemDataList
    oldValue.value = dataInfo.value
    //更改对应值
    keyBoradObj.value.text = dataInfo.value[keyBoradIndex.value]?.isEdit ? dataInfo.value[keyBoradIndex.value].title : ''
    keyBoradObj.value.num = dataInfo.value[keyBoradIndex.value]?.isEdit ? dataInfo.value[keyBoradIndex.value].value + '' : '0'
    keyMinValue.value = baseInfor.value.isDebugGood ? baseInfor.value.debugGoodOutputAdjustment : 0
    //正品数大于计划产量 未完上报按钮禁用
    btnStatu.value = Number(dataInfo.value[0]?.value) >= baseInfor.value.planOutput
}
const wastNum = computed(() => {
    let wastTatal = 0
    materialBadDetailList.value.map(item => {
        wastTatal += item.num
    })
    return wastTatal
});
//更新实时数
const updateRealData = (sign: string, newValue: number) => {
    materialBadDetailList.value.map(item => {
        if (item.code == sign) item.num = newValue
    })
    dataInfo.value[keyBoradIndex.value].value = String(wastNum.value);

}
onMounted(() => {
    bableFun(props.data)
    radioList.value = (store.state.inforReport?.combineProcedureList) ? store.state.inforReport?.combineProcedureList :
        ((props.productionData?.combineProcedureList && props.productionData?.combineProcedureList.length > 0)
            ? props.productionData.combineProcedureList : [])
    store.commit("inforReport/setCombineProcedureList", {
        combineProcedureList: radioList.value
    });
})
//定义回调事件




// ---------------------数据变量定义-------------------------
const store = useStore();
//变量定义
const oldValue = ref([])
//键盘值
let keyBoradIndex = ref<number>(0)
//键盘标题与键盘值
const keyBoradObj = ref({
    text: '',
    num: '0'
})
let baseInfor = ref({
    recordGoodNum: store.state.inforReport.statue ? store.state.inforReport.baseInfor.recordGoodNum : props.recordGoodNum,
    planOutput: store.state.inforReport.statue ? store.state.inforReport.baseInfor.planOutput : props.planOutput,
    isDebugGood: store.state.inforReport.statue ? store.state.inforReport.baseInfor.isDebugGood : props.productionData.isDebugGood,
    debugOutputAdjustment: store.state.inforReport.statue ? store.state.inforReport.baseInfor.debugOutputAdjustment : props.data.debugOutputAdjustment,
    debugGoodOutputAdjustment: store.state.inforReport.statue ? store.state.inforReport.baseInfor.debugOutputAdjustment : props.data.debugGoodOutputAdjustment
})
//键盘最小值
let keyMinValue = ref<number>(0)
//正品数 旧值
let goodOutputOldValue = ref<string>('0')
//未完上报按钮禁用状态
let btnStatu = ref<boolean>(false)
//自定义问题
const options = ref<SelectProps["options"]>([
    { value: "数采设备故障", label: " 数采设备故障" },
    { value: "接单不及时", label: "接单不及时" },
    { value: "其他", label: "其他" },
]);
//事件触发等待框
const loading = ref<boolean>(false);
//定义完工上报类型
const completeType = ref<string>('')
const radioList = ref([])
//隐藏本控件
//错误提示框
let messageVisible = ref<boolean>(false)
let materialWasteShow = ref<boolean>(false)
let dataInfo = ref<IItemData[]>([])
let materialBadDetailList = ref<IPostMachineProductionCountReportMaterialBadDetailList[]>([])
let selectStyle = ref({
    borderWidth: "1px",
    borderStyle: 'solid',
    borderColor: '#13C2C2',
    boxShadow: "inset 0px 3px 16px 0px rgba(0, 0, 0, 0.1)"
})
watch(() => keyBoradIndex.value, newVal => {
    if (newVal != 0) {

        dataInfo.value[0].value = Number(dataInfo.value[0].value) >= (baseInfor.value.isDebugGood ? baseInfor.value.debugGoodOutputAdjustment : 0) ? dataInfo.value[0].value + '' : baseInfor.value.debugGoodOutputAdjustment + ''
    }
}, {
    deep: true
})
// ---------------------方法定义-------------------------
//操作方法
const onHandle = (status: 'cance' | 'complete', type: string) => {
    dataInfo.value[0].value = Number(dataInfo.value[0].value) >= (baseInfor.value.isDebugGood ?
        baseInfor.value.debugGoodOutputAdjustment : 0) ?
        dataInfo.value[0].value + '' : baseInfor.value.debugGoodOutputAdjustment + ''
    if (keyBoradIndex.value == 0) {
        keyBoradObj.value.num = dataInfo.value[keyBoradIndex.value].value + ''
    }
    loading.value = true;
    //临时先增加，判定修改原因是否不为空
    if (status == 'complete') {
        if (dataInfo.value && dataInfo.value.length > 0 && (!dataInfo.value[1].disabled) && dataInfo.value[1] && (dataInfo.value[1].value == undefined)) {
            message.error("请选择修改原因再上报!")
            loading.value = false;
            return;
        }
        completeType.value = type == 'y' ? (Number(dataInfo.value[0]?.value || 0) < baseInfor.value.planOutput ? 'y' : 'n') : ''
        if (Number(dataInfo.value[0]?.value || 0) < baseInfor.value.planOutput && type == 'y') {
            messageVisible.value = true;
            loading.value = false;
            return;
        }
    } else {
        store.commit("inforReport/removeCombineProcedureList");
    }
    emit("onResultOperate", status, dataInfo.value, materialBadDetailList.value, completeType.value, baseInfor.value.recordGoodNum)
    loading.value = false;
}

//触发条件校验
const vaildValue = (index: number, num: number) => {
    if (index === 0) {
        dataInfo.value[dataInfo.value[index].vaild].disabled = (props.data.goodOutputAdjustment -
            (Number(goodOutputOldValue.value) - Number(dataInfo.value[index].value)) == 0 ? true : false)
        if (dataInfo.value[dataInfo.value[index].vaild].disabled) {
            dataInfo.value[dataInfo.value[index].vaild].value = null;
        }
        btnStatu.value = Number(dataInfo.value[0]?.value) >= baseInfor.value.planOutput
    }
}
//文字直接改变的时候做监听处理
const onChangeValue = (title: string, index: number) => {
    if (title == '材废' && dataInfo.value[index].isEdit) {
        materialWasteShow.value = true
        keyBoradIndex.value = index
        keyBoradObj.value = {
            text: '',
            num: '0'
        }
        return
    }
    if (dataInfo.value[index].isEdit) {
        //输入框高亮
        keyBoradIndex.value = index
        //更改对应值
        keyBoradObj.value.text = dataInfo.value[keyBoradIndex.value]?.isEdit ? dataInfo.value[keyBoradIndex.value].title : ''
        keyBoradObj.value.num = dataInfo.value[keyBoradIndex.value]?.isEdit ? dataInfo.value[keyBoradIndex.value].value + '' : '0'
        materialWasteShow.value = false
    }
    keyMinValue.value = baseInfor.value.isDebugGood && index == 0 ? baseInfor.value.debugGoodOutputAdjustment : 0
}

//完工上报--数量调整
const onChangeNumber = (value: number) => {
    dataInfo.value[keyBoradIndex.value].value = value + ''
    vaildValue(keyBoradIndex.value, value)
}
//警告处理
const onReceivingHandleOk = (status: 'cance' | 'complete') => {
    if (status === 'cance') {
        messageVisible.value = false;
    } else {
        store.commit("inforReport/removeKeepInforStatu", {});

        messageVisible.value = false;
        emit("onResultOperate", status, dataInfo.value, materialBadDetailList.value, completeType.value, baseInfor.value.recordGoodNum)
        loading.value = false;
    }
}
const onCheckChange = (item) => {
    item.selected = item.selected == 'y' ? 'n' : 'y'
    if (radioList.value.length > 0) {
        store.commit("inforReport/setCombineProcedureList", {
            combineProcedureList: radioList.value
        });
    }

}


return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(jtabBar, {
      class: "jtabBarView",
      data: [{ id: '1', value: '完工上报', select: true }],
      select: "1"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(reportTitle, {
                  name: '计划产量',
                  value: _unref(baseInfor).planOutput
                }, null, 8, ["value"]),
                _createVNode(reportTitle, {
                  name: '调机数',
                  value: _unref(baseInfor).debugOutputAdjustment
                }, null, 8, ["value"]),
                _createVNode(reportTitle, {
                  name: '调机正品数',
                  value: _unref(baseInfor).debugGoodOutputAdjustment
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataInfo), (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.title
                  }, [
                    (!item.hide)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(item.title), 1),
                          (item.filedType === 'input')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["inputClass flex justify-between", { inputClassDisabled: item.disabled }]),
                                style: _normalizeStyle(_unref(keyBoradIndex) == index ? _unref(selectStyle) : ''),
                                onClick: ($event: any) => (onChangeValue(item.title, index))
                              }, [
                                _createTextVNode(_toDisplayString(item.value) + " ", 1),
                                (item.icon)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                      _createVNode(_unref(EllipsisOutlined))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 14, _hoisted_8))
                            : _createCommentVNode("", true),
                          (item.filedType === 'select')
                            ? (_openBlock(), _createBlock(_component_a_select, {
                                key: 1,
                                disabled: item.disabled,
                                class: "selectClass",
                                value: item.value,
                                "onUpdate:value": ($event: any) => ((item.value) = $event),
                                options: options.value,
                                placeholder: item.disabled ? '无需选择调整原因' : '请选择修改原因',
                                size: "large",
                                onChange: ($event: any) => (onChangeValue(item.title, index)),
                                getPopupContainer: (triggerNode) => triggerNode.parentNode
                              }, null, 8, ["disabled", "value", "onUpdate:value", "options", "placeholder", "onChange", "getPopupContainer"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (!_unref(materialWasteShow))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(keyBoradObj.value.text), 1),
                    _createVNode(keyBorad, {
                      value: keyBoradObj.value,
                      "min-value": _unref(keyMinValue),
                      onPutKeyBorad: onChangeNumber
                    }, null, 8, ["value", "min-value"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    (_unref(materialBadDetailList).length < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, "当前无不良品项，请联系管理人员添加"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(materialBadDetailList), (item, index) => {
                            return (_openBlock(), _createBlock(titleButton, {
                              key: index,
                              name: item.label,
                              sign: item.code,
                              value: item.num,
                              onOnChangeValue: updateRealData,
                              minValue: 0
                            }, null, 8, ["name", "sign", "value"]))
                          }), 128))
                        ]))
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (props.productionData.canCombine && props.productionData.combineProcedureList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radioList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "process_item mr-6",
                          key: index
                        }, [
                          (item.canUnsel == 'n')
                            ? (_openBlock(), _createBlock(_component_a_radio, {
                                key: 0,
                                checked: true,
                                disabled: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_a_checkbox, {
                                key: 1,
                                onChange: ($event: any) => (onCheckChange(item)),
                                checked: item.selected == 'y'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["onChange", "checked"]))
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(JablilBtn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onHandle('cance', ''))),
                name: '取消',
                "bg-color": '#606266'
              }),
              _createVNode(JablilBtn, {
                name: '未完上报',
                "bg-color": _unref(btnStatu) ? '#A3BCE6' : '#1756BF',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onHandle('complete', 'n'))),
                disable: _unref(btnStatu)
              }, null, 8, ["bg-color", "disable"]),
              _createVNode(JablilBtn, {
                name: '完工上报',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onHandle('complete', 'y')))
              })
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(MessageShow, {
      show: _unref(messageVisible),
      title: "完工上报",
      detail: "当前正品数小于计划生产数，是否继续缺数上报？",
      onOnResultOperate: onReceivingHandleOk,
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("p", _hoisted_26, _toDisplayString(__props.planOutput), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(dataInfo)[0]?.value), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})